export const AGENT_TYPES = {
  TELEPORT: 'TELEPORT',
  PROXY: 'PROXY',
};
